export interface PageInformationDTO {
    rowsTotalCount?: number;
    rowFrom?: number;
    rowTo?: number;
    pageNumber?: number;
    pagesTotalCount?: number;
}
